// src/AuctionAdmin.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useParams } from 'react-router-dom';  // For getting the auction code from the URL

const AuctionAdmin = () => {
  const { auctionCode } = useParams();  // Get auction code from the URL
  const [auctionItems, setAuctionItems] = useState([]);

  useEffect(() => {
    // Fetch auction items for the given auction code
    const fetchAuctionItems = async () => {
      const { data, error } = await supabase
        .from('auction_items')
        .select('*')
        .eq('auction_code', auctionCode);

      if (error) {
        console.error('Error fetching auction items:', error);
      } else {
        setAuctionItems(data);
      }
    };

    fetchAuctionItems();
  }, [auctionCode]);

  return (
    <div>
      <h1>Auction Admin - {auctionCode}</h1>
      <h2>Manage Auction Items</h2>
      {auctionItems.length === 0 ? (
        <p>No items in this auction yet.</p>
      ) : (
        auctionItems.map((item) => (
          <div key={item.id}>
            <p>Item: {item.item_name}</p>
            <p>Description: {item.description}</p>
            <p>Starting Bid: ${item.starting_bid}</p>
            {/* Add options to update or delete the item here */}
          </div>
        ))
      )}
    </div>
  );
};

export default AuctionAdmin;
